import script from "./OwnerDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./OwnerDetail.vue?vue&type=script&setup=true&lang=js"

import "./OwnerDetail.vue?vue&type=style&index=0&id=a76824c0&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a76824c0"]])

export default __exports__